// extracted by mini-css-extract-plugin
export default {"container":"Validation_container__Y0Sm9","box":"Validation_box__auk22","logo":"Validation_logo__fTTlx","content":"Validation_content__lEg3h","title":"Validation_title__QUyn-"};